import { fromJS } from 'immutable'; // use of immutablejs for various js operations to simplify our work

import { getPublicProfile, getPublicRequestById } from 'services/saProfile.service';
import {
  REQUESTED,
  FAILED,
  SUCCESSFUL,
  PUBLIC_ATHLETE_REQUEST,
  SAVE_USER_IMAGE, // eslint-disable-line
} from './actionTypes';

export function getSAProfile(id) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    getPublicProfile(id)
        .then((data) => {
          if (data) {
            dispatch({
              type: SUCCESSFUL,
              profile: fromJS(data),
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: FAILED,
            error: err,
          });
        });
  };
}

export function getRequestById(id) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    getPublicRequestById(id)
            .then((data) => {
              if (data) {
                dispatch({
                  type: PUBLIC_ATHLETE_REQUEST,
                  request: fromJS(data.request),
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: FAILED,
                error: err,
              });
            });
  };
}



// WEBPACK FOOTER //
// ./src/containers/PublicAthletePage/actions.js